<header class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <a href="http://www.snagajob.com/"><img src="/assets/brand/snagajob-white.svg"></a>
        </div>
    </div>
</header>

<div class="container">
    <div class="row">
        <div id="customer-site-not-found-content">
            <div id="customer-site-not-found-content-404">404</div>
            <div id="customer-site-not-found-content-msg">The site you are looking for cannot be found.</div>
            <a class="btn btn--action btn--lg" href="http://www.snagajob.com/">Visit snagajob.com</a>
        </div>
    </div>
</div>
